import { getStoredStopId } from "./stopIds.js";
import { MAX_RECENT_STOP_IDS } from "./recentStopConstants.js";

export function getRecentStopIds(recents) {
  if (!Array.isArray(recents)) {
    return [];
  }

  return Array.from(
    new Set(
      recents
        .map((recentStop) => getStoredStopId(recentStop))
        .filter((stopId) => typeof stopId === "string" && stopId.length > 0),
    ),
  ).slice(0, MAX_RECENT_STOP_IDS);
}

export function buildRecentStopSummaryUrl(stopIds, version) {
  const ids = Array.from(
    new Set(
      (Array.isArray(stopIds) ? stopIds : []).filter(
        (stopId) => typeof stopId === "string" && stopId.length > 0,
      ),
    ),
  ).slice(0, MAX_RECENT_STOP_IDS);

  if (!ids.length) {
    return null;
  }

  const params = new URLSearchParams();
  ids.forEach((stopId) => params.append("ids", stopId));

  if (version) {
    params.set("v", version);
  }

  return `/api/stops/summary?${params.toString()}`;
}
